import FormatterHelper from "@/scripts/helpers/formatter.helper";

const formatter = new FormatterHelper();

export const GiftsHelper = {
  /**
   * Calcula o upsell e retorna lista de brindes elegíveis com contrapartida.
   *
   * @param {number} checkoutValue Valor atual informado pelo doador.
   * @param {Object} giftsConfig Objeto retornado pela API de config de brindes (BonusConfig).
   * @param {Array} campaignGifts Lista completa de brindes da campanha atual.
   * @param {Array} appreciationList Lista de contrapartidas da campanha atual.
   * @param {Object} campaignService Instância do serviço de campanhas.
   * @param {string|number} donorId ID do doador logado.
   */
  async calculateGiftUpsell({
    checkoutValue,
    giftsConfig,
    campaignGifts,
    appreciationList,
    campaignService,
    donorId
  }) {
    try {
      const cfg = giftsConfig?.giftConfig || giftsConfig;

      let BASE = 0;

      if (typeof giftsConfig.lastSellValue === "number" && giftsConfig.lastSellValue > 0) {
        BASE = giftsConfig.lastSellValue;
      } else {
        BASE = checkoutValue;
      }

      // Se o checkout atual for maior que o histórico, ele vira a base
      if (checkoutValue > BASE) {
        BASE = checkoutValue;
      }

      const minTarget = Math.round(
        (giftsConfig.minTarget || BASE * (1 + cfg.minPercentageMaintenanceTax / 100)) * 100
      ) / 100;

      const maxTarget = Math.round(
        (giftsConfig.maxTarget || BASE * (1 + cfg.maxPercentageMaintenanceTax / 100)) * 100
      ) / 100;

      if (checkoutValue > maxTarget) {
        alert("🚫 Checkout acima do máximo permitido, sem upsell.");
        return { base: BASE, minTarget, maxTarget, newTotal: null, gifts: [], appreciation: null };
      }

      let newTotal = minTarget;
      const thresholds = appreciationList.map(a => a.firstValue).sort((a, b) => a - b);
      const nextTier = thresholds.find(t => t >= newTotal && t <= maxTarget);

      if (checkoutValue >= minTarget && checkoutValue <= maxTarget) {
        const tierCandidate = thresholds.find(t => t >= checkoutValue && t <= maxTarget);
        newTotal = tierCandidate || checkoutValue;
      } else if (checkoutValue < minTarget) {
        newTotal = nextTier || minTarget;
      }

      // Sanitiza e arredonda
      newTotal = Math.min(Math.max(newTotal, checkoutValue), maxTarget);
      newTotal = Math.round(newTotal * 100) / 100;

      const giftsList = campaignGifts.filter(g => {
        const init = parseFloat(g.initialValue);
        const fin = parseFloat(g.finalValue);
        return g.active && newTotal >= init && newTotal <= fin;
      });

      if (!giftsList.length) {
        return { base: BASE, minTarget, maxTarget, newTotal, gifts: [], appreciation: null };
      }

      const appreciation = appreciationList.find(
        a => newTotal >= a.firstValue && newTotal <= (a.lastValue || Infinity)
      );

      const gifts = giftsList.map(gift => {
        const bonus = {
          type:
            appreciation?.name?.trim() !== ""
              ? appreciation.name
              : `De ${formatter.formatMoneyWithCents(appreciation?.firstValue || 0)} à ${formatter.formatMoneyWithCents(appreciation?.lastValue || 0)}`,
          title: gift.name,
          additional: formatter.formatMoneyWithCents(newTotal - checkoutValue),
          total: formatter.formatMoneyWithCents(newTotal),
          img: gift.file.path,
          product: gift,
          benefits: []
        };

        const benefitsDescriptions = (appreciation?.campaignAppreciationItems || []).flatMap(item =>
          item.description.split("•")
        );

        benefitsDescriptions.forEach(desc => {
          bonus.benefits.push(
            desc
              .replaceAll("<span>", "")
              .replaceAll("</span>", "")
              .replaceAll("<li>", "")
              .replaceAll("</li>", "")
          );
        });

        return bonus;
      });

      gifts.sort(
        (a, b) => parseFloat(a.product.initialValue) - parseFloat(b.product.initialValue)
      );

      return { base: BASE, minTarget, maxTarget, newTotal, gifts, appreciation };

    } catch (err) {
      return null;
    }
  }
};